<template>
  <div>
    <v-card
      :loading="loading"
      v-if="countAll > 0 && loading === false"
      rounded="lg"
      class="animate__animated animate__fadeInUp"
    >
      <v-toolbar class="elevation-0">
        <v-toolbar-title>
          <lord-icon
            src="https://cdn.lordicon.com/fqbvgezn.json"
            trigger="loop"
            colors="primary:#545454,secondary:#16a9c7"
            style="width: 40px; height: 40px"
          >
          </lord-icon
          >เปิดสอน สาขาวิชา — ผู้เรียนจริง
          <div v-if="entranceYear" class="caption grey--text">
            ข้อมูล ณ ปีการศึกษา {{ entranceYear }} รวม {{ numberWithCommas(totalStudents) }} คน
          </div>
        </v-toolbar-title>

        <v-spacer></v-spacer>
      </v-toolbar>

      <v-data-table
        :items="rows"
        :headers="header"
        :search="search"
      >
        <template v-slot:top>
          <div>
            <v-text-field
              v-model="search"
              label="ค้นหา"
              prepend-icon="mdi-magnify"
            ></v-text-field>
          </div>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
export default {
  name: 'DashboardOvecMasterCollegeRang',

  data() {
    return {
      ApiKey: 'HRvec2021',
      loading: true,
      search: '',
      rows: [],
      entranceYear: null,
      header: [
        { text: 'ประเภทวิชา', align: 'center', value: 'subjectTypeNameTh' },
        { text: 'สาขาวิชา', align: 'center', value: 'minorNameTh' },
        { text: 'ระดับชั้น', align: 'center', value: 'gradeNameTh' },
        { text: 'ปีการศึกษา', align: 'center', value: 'entranceYear' },
        { text: 'จำนวน (คน)', align: 'center', value: 'cnt' },
      ],
      countAll: 0,
    }
  },

  async mounted() {
    await this.queryStudentStatSummary()
  },

  methods: {
    numberWithCommas(x) {
      x = String(x)
      var pattern = /(-?\d+)(\d{3})/
      while (pattern.test(x)) x = x.replace(pattern, '$1,$2')
      return x
    },

    async queryStudentStatSummary() {
      try {
        this.loading = true
        let result = await this.$http
          .post('student_stat_summary_college.php', {
            ApiKey: this.ApiKey,
            college_id: this.college_ID,
          })
          .finally(() => (this.loading = false))

        if (!result.data.status) {
          this.rows = []
          this.countAll = 0
          return
        }

        this.entranceYear = result.data.entranceYear
        this.rows = result.data.rows || []
        this.countAll = this.rows.length
      } catch (error) {
        this.rows = []
        this.countAll = 0
      } finally {
        this.loading = false
      }
    },
  },

  computed: {
    college_ID(){
      return this.$route.query.college_ID
    },
    totalStudents() {
      return this.rows.reduce((sum, r) => sum + (parseInt(r.cnt) || 0), 0)
    }
  },
}
</script>
